<template>
  <v-autocomplete
    hide-details="auto"
    :items="incomeCategories"
    :loading="loading"
    v-model="selectedIncomeCategory"
    item-text="name"
    item-value="id"
    label="Income Category"
    clearable
    outlined
    dense
    @change="emitInput"
    :search-input.sync="searchCategory"
  ></v-autocomplete>
</template>
<script>
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    incomeCategories: [],
    selectedIncomeCategory: null,
    searchCategory: null,
    loading: false,
  }),
  methods: {
    emitInput() {
      this.$emit("input", this.selectedIncomeCategory);
    },
    getIncomeCategoryByQuery() {
      this.loading = true;
      this.$store
        .dispatch("sitesetting/GetIncomeCategories")
        .then((res) => {
          this.loading = false;
          this.incomeCategories = (res.data && res.data.data) || [];
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    clear() {
      this.selectedIncomeCategory = null;
    },
    searchCategory() {
      this.getIncomeCategoryByQuery();
    },
  },
  created() {
    this.getIncomeCategoryByQuery();
  },
};
</script>
